export const PAGE_NAME = {
  INVENTORY_MANAGEMENT: "Inventory Management",
  ASSET_MANAGEMENT: "Asset_Management"
}

export const BUG_TYPE = {
  BUG: "Bug",
  FEATURE_REQUEST: "Feature Request"
}

export const STATUS = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  MORE_INFO_NEEDED: "More Info Needed",
  DONE: "Done"
}